import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {PortalApiService} from './../../../shared/services/api/portal-api.service';
import {AppSettingsService} from './../../../shared/services/app-settings.service';
import {VoucherPayment} from './../models/voucher-payment';
import {AvailableExam} from './../models/available-exam';
import { finalize } from 'rxjs/operators';

const apiEndpoints = {
  exams: 'voucher/exams',
  purchase: 'voucher/purchase'
};

@Injectable()
export class VoucherPurchaseService {
  constructor(private appSettings: AppSettingsService,
    private portalApiService: PortalApiService)
    {
    }

    purchaseVoucher(voucherPaymentData: VoucherPayment): Observable<VoucherPayment> {
      return this.portalApiService.post(apiEndpoints.purchase, voucherPaymentData)
        .pipe(finalize(() => null));
    }
    
    getVouchersAvailable() {
      return this.portalApiService.get(apiEndpoints.exams)
        .pipe(finalize(() => null));
    }
}